import {connect} from 'react-redux'
import UpcomingPicksArea from '../../components/manager_side/picking_area/upcoming_picks_area'

const mapStateToProps = (state) => ({
  upcomingPicks: state.draftManagerSide.upcomingPicks,
})

export default connect(mapStateToProps, {})(UpcomingPicksArea)
